import { SubmissionInfo } from '../../../../submission-list-view.types';

interface GetSelectedSubmissionsPayload {
  loadedSubmissions: SubmissionInfo[];
  selectedSubmissions: SubmissionInfo[];
  isSelectAllActive: boolean;
}

export function getSelectedSubmissions({
  isSelectAllActive,
  loadedSubmissions,
  selectedSubmissions,
}: GetSelectedSubmissionsPayload): SubmissionInfo[] {
  if (isSelectAllActive) {
    return loadedSubmissions;
  }
  return selectedSubmissions;
}
